import {DateHelper} from '@/shared/utils';

export default (date: any): string => {
	return DateHelper.toDisplayDate(date);
};